import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientModule,
} from '@angular/common/http';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CalendarModule } from 'primeng/calendar';
import { SliderModule } from 'primeng/slider';
import { DialogModule } from 'primeng/dialog';
import { MultiSelectModule } from 'primeng/multiselect';
import { ContextMenuModule } from 'primeng/contextmenu';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { InputTextModule } from 'primeng/inputtext';
import { ProgressBarModule } from 'primeng/progressbar';
import { DropdownModule } from 'primeng/dropdown';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

import {
  AccumulationChartAllModule,
  RangeNavigatorAllModule,
  CategoryService,
  DataLabelService,
  LegendService,
  PieSeriesService,
  StackingLineSeriesService,
  ColumnSeriesService,
  TooltipService,
  DateTimeService,
  ChartAnnotationService,
  RangeColumnSeriesService,
  ScrollBarService,
  ChartAllModule,
} from '@syncfusion/ej2-angular-charts';
import { CircularGaugeModule } from '@syncfusion/ej2-angular-circulargauge';

// Page
import { LoginModule } from './pages';
import { SharedModule } from './shared/shared.module';
import { StoreModule } from '@ngrx/store';
import { metaReducers, reducers } from './root-store';
import { EffectsModule } from '@ngrx/effects';
import { ConfigEffects } from './root-store/config/effects/config.effects';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { LocaleEffects } from './root-store/locale/locale.effects';
import { BiaEffects } from './root-store/bia/bia.effects';
import { SaBiaEffects } from './root-store/sa-bia/sa-bia.effects';
import { SaResourceEffects } from './root-store/sa-resources/sa-resources.effects';
import { SaRaEffects } from './root-store/sa-ra/sa-ra.effects';
import { BiaImpactService } from './core/service/bia-impact.service';
import { SaRaService } from 'src/app/services/sa-ra.service';
import { UserEffects } from './root-store/user/user.effects';
import { WorkflowEffects } from './root-store/workflow/workflow.effects';
import { BcpEffects } from './root-store/bcp/bcp.effects';
import { ProductInfoModule } from './pages/product-info/product-info.module';
import { TestingModule } from './pages/testing/testing.module';
import { ErrorCatchingInterceptor } from './interceptors/error-catching.interceptor';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    AppRoutingModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    HttpClientModule,
    CalendarModule,
    SliderModule,
    DialogModule,
    MultiSelectModule,
    ContextMenuModule,
    DropdownModule,
    ButtonModule,
    ToastModule,
    InputTextModule,
    ProgressBarModule,
    FormsModule,
    LoginModule,
    ProductInfoModule,
    SharedModule,
    TestingModule,
    AccumulationChartAllModule,
    RangeNavigatorAllModule,
    CircularGaugeModule,
    ChartAllModule,
    StoreModule.forRoot(reducers, { metaReducers }),
    EffectsModule.forRoot([
      ConfigEffects,
      LocaleEffects,
      BiaEffects,
      SaBiaEffects,
      SaResourceEffects,
      SaRaEffects,
      UserEffects,
      BcpEffects,
      WorkflowEffects,
    ]),
    StoreDevtoolsModule.instrument({ maxAge: 40 }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  exports: [TranslateModule],
  providers: [
    BiaImpactService,
    SaRaService,
    CategoryService,
    DataLabelService,
    LegendService,
    PieSeriesService,
    StackingLineSeriesService,
    ColumnSeriesService,
    TooltipService,
    DateTimeService,
    ChartAnnotationService,
    RangeColumnSeriesService,
    ScrollBarService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorCatchingInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
